import { createFileRoute } from "@tanstack/react-router"
import DesignSystemDatePicker from "~/pages/design-system/components/DatePicker"

export const Route = createFileRoute("/_auth/internal/design-system/components/date-picker")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemDatePicker />
}
